<template>
	<appBox v-if="newTable" title="Nova de Tabela">
		<div slot="body" class="row">
			<div class="col-sm-4">
				SmartForm
				<div class="input-group">
					<select
						v-if="assets != null"
						v-model="sendData.cForm"
						type="text"
						class="form-control"
						:disabled="assets == null"
						@change="loadAsset()"
					>
						<option value="">Escolher</option>
						<option
							v-for="(option, index) in assets.forms"
							:key="index"
							:value="option.cod"
						>
							{{ option.titulo }}
						</option>
					</select>
					<div class="input-group-btn">
						<button class="btn btn-primary" @click="loadAsset()">
							<i class="fa fa-refresh"></i>
						</button>
					</div>
				</div>
			</div>
			<div class="col-sm-5">
				Titulo
				<input
					type="text"
					v-model="sendData.titulo"
					@input="sendData.id = pId($event.target.value)"
					class="form-control"
				/>
			</div>
			<div class="col-sm-3">
				Id Tabela
				<input
					type="text"
					v-model="sendData.id"
					class="form-control"
					disabled
				/>
			</div>
			<div class="clearfix"></div>
			<br />
		</div>
		<div slot="body" v-if="form_base != null" class="row">
			<div class="col-sm-6">
				Exibir <small>(Colunas que iram aparecer na tabela)</small>
				<appDropDraw
					:asset="form_base.inputs"
					v-model="sendData.exibir"
					cod="id"
					title="label"
				/>
			</div>
			<div class="col-sm-6">
				Filtros <small>(Filtros para essa tabela)</small>
				<appDropDraw
					disabled
					:asset="form_base.inputs"
					v-model="sendData.filtros"
					cod="id"
					title="label"
				/>
			</div>
			<div class="clearfix"></div>
			<br />
		</div>
		<div slot="footer">
			<button
				v-if="sendData.cod != undefined"
				class="btn btn-default pull-left"
				@click="newTable = false"
			>
				<i class="fa fa-arrow-left"></i>
				Voltar
			</button>
			<button
				class="btn btn-success pull-right"
				:disabled="validadeForm"
				@click="save"
			>
				<i class="fa fa-save"></i>
				Salvar
			</button>
		</div>
	</appBox>
	<viewTable
		v-else
		ref="viewTable"
		:data="sendData"
		:fBase="form_base"
		@openSettings="newTable = true"
		@returnBase="returnBase"
	/>
</template>
<script>
	import appBox from 'app/box';
	import WBS from 'js/http';
	import appDropDraw from 'app/drop-draw';
	import parseId from 'js/parseId';
	import toastr from 'toastr';
	import viewTable from './components/view-table.vue';
	import { clone } from 'lodash';

	let reset = { cForm: '', exibir: [], filtros: [], titulo: '', id: '' };

	export default {
		name: 'SmartTable',
		components: { appBox, appDropDraw, viewTable },
		data() {
			return {
				assets: null,
				form_base: null,
				newTable: true,
				sendData: clone(reset),
			};
		},
		watch: {
			'$route.params.id': function (val) {
				if (val == 'create') {
					this.returnBase();
					this.loadAsset();
				} else {
					this.request_table(val);
				}
			},
		},
		methods: {
			request_table: function (page) {
				WBS.send('private-read-smartTables', { id: page }, (resp) => {
					if (resp.status == 'success') {
						if (resp.data != undefined) {
							this.loadTable(resp.data);
						} else {
							this.returnBase();
							this.sendData.id = this.$route.params.id;
						}
					}
				});
			},
			returnBase() {
				this.newTable = true;
				this.form_base = null;
				this.sendData = clone(reset);
				// this.$emit("update")
			},
			pId(val) {
				return parseId(val);
			},
			isActive(id) {
				return this.sendData.id == id ? 'active' : '';
			},
			loadAsset(callback = null) {
				WBS.send(
					'protected-read-assetsSmartTables',
					this.sendData.cForm,
					(resp) => {
						if (this.sendData.cForm == '') {
							this.assets = resp.data;
						} else {
							this.form_base = resp.data;
							this.exibir = [];
							this.filtros = [];
							if (callback != null) callback();
						}
					}
				);
			},
			loadTable(table) {
				this.newTable = false;
				this.sendData = clone(table);
				this.loadAsset((e) => {
					setTimeout((i) => {
						this.$refs.viewTable.reloadTable();
					}, 150);
				});
			},
			save() {
				WBS.send('private-save-smartTables', this.sendData, (resp) => {
					if (resp.status == 'success') {
						this.sendData = resp.data;
						toastr.success('Tabela criada com sucesso!');
					} else {
						toastr.error('Erro ao criar tabela!');
						console.log(resp);
					}
				});
			},
		},
		computed: {
			validadeForm() {
				if (
					this.sendData.titulo != '' &&
					this.sendData.exibir.length > 0
				)
					return false;
				return true;
			},
		},
		mounted() {
			this.loadAsset();
			this.$emit('setHeader', [
				'Smart Tables',
				'Gestão de Tabelas de complementares',
			]);
			if (this.$route.params.id == 'create') {
				this.returnBase();
				this.loadAsset();
			} else {
				this.request_table(this.$route.params.id);
			}
		},
	};
</script>
<style scoped>
	small {
		color: #989898;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/tables/table.vue